import convert from 'convert'

export const surfaceAreaPerLitre = (unit: string, surfaceArea: number) => {
  if (unit === 'metres') {
    return surfaceArea
  }
  return Math.floor(convert(surfaceArea, 'm2').to('sq ft'))
}

export const unit = (calculatorUnit: string) => {
  switch (calculatorUnit) {
    case 'metres':
      return 'm'
    case 'feet':
      return 'ft'
    default:
      return ''
  }
}

export const calculatePaintNeeded = (
  calculatedCoverage: number,
  calculatorUnit: string,
  surfaceArea: number
) => {
  const paintNeeded = Math.ceil(
    calculatedCoverage / surfaceAreaPerLitre(calculatorUnit, surfaceArea)
  )
  return paintNeeded
}

export const getCoverageOfPaint = (
  paint: number,
  calculatorUnit: string,
  surfaceArea: number
) => {
  return paint * surfaceAreaPerLitre(calculatorUnit, surfaceArea)
}

export const getActualCoverageOfPaintNeeded = (
  calculatedCoverage: number,
  calculatorUnit: string,
  surfaceArea: number
) => {
  if (calculatedCoverage === 0) return '-'
  let litres = calculatePaintNeeded(
    calculatedCoverage,
    calculatorUnit,
    surfaceArea
  )
  return `${getCoverageOfPaint(litres, calculatorUnit, surfaceArea)}${unit(
    calculatorUnit
  )}²`
}

export const TwentyLitreLocales = ['en-au']

// function to group number litres into 20, 10, 5 and 1
export const groupLitres = (
  calculatedCoverage: number,
  calculatorUnit: string,
  locale: string,
  surfaceArea: number
) => {
  let litres = calculatePaintNeeded(
    calculatedCoverage,
    calculatorUnit,
    surfaceArea
  )
  const groups = TwentyLitreLocales.includes(locale)
    ? [20, 10, 5, 1]
    : [10, 5, 1]
  const grouped = groups.map((group) => {
    const count = Math.floor(litres / group)
    litres -= count * group
    return { group, count }
  })
  return grouped
}

// function to convert groped litres into string
export const groupLitresToString = (
  calculatedCoverage: number,
  calculatorUnit: string,
  locale: string,
  surfaceArea: number
) => {
  if (calculatedCoverage === 0) return '-'
  const grouped = groupLitres(
    calculatedCoverage,
    calculatorUnit,
    locale,
    surfaceArea
  )

  return grouped
    .map(({ group, count }) => {
      if (count === 0) return ''
      return `${count} x ${group}L`
    })
    .filter(Boolean)
    .join(', ')
}
